<div class="back-btn w-link-btn" (click)="goBack()">
  <i class="mdi mdi-chevron-left"></i>
  <span>{{'RECEIPT.BACK' | translate}}</span>
</div>
<div class="container">
  <div class="order-box w-depth">
    <div class="order-details w-depth">
      <div class="detail-row">
        <div class="detail-icon">
          <i class="wahii-icon-can-2"></i>
        </div>
        <div class="detail-text">
            <span>
              {{order?.specs?.recipient?.type}}
              <span *ngIf="order?.specs?.recipient?.feet">{{order?.specs?.recipient?.feet}} ft</span>
              <br>
            </span>
          <div *ngIf="order?.specs?.recipient?.name">{{order?.specs?.recipient?.name}}</div>
          <div *ngIf="order?.specs?.recipient?.location">{{order?.specs?.recipient?.location}}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-icon">
          <i class="wahii-icon-jerrycan"></i>
        </div>
        <div class="detail-text">
          <div>{{order?.specs?.product?.name}}</div>
          <div>{{order?.totals.amount}} <span *ngIf="order">{{'GALLONS' | translate}}</span></div>
          <div>{{order?.specs?.recipient?.fillUp}}</div>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-icon">
          <i class="wahii-icon-calendar2-outline"></i>
        </div>
        <div class="detail-text">
          <div>
            {{order?.deliveryDate | date: 'MM/dd/yyyy'}}
            <span *ngIf="order?.deliveryHour"> &#124; {{'TIME.' + order?.deliveryHour?.toUpperCase() | translate}}</span>
          </div>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-icon">
          <i class="wahii-icon-marker2-outline"></i>
        </div>
        <div class="detail-text">{{order?.fullAddress}}</div>
      </div>
      <div class="detail-row" *ngIf="order?.comments">
        <div class="detail-icon">
          <i class="wahii-icon-info-2-outline"></i>
        </div>
        <div class="detail-text">{{order?.comments}}</div>
      </div>
      <div class="detail-row promo-detail" *ngFor="let discount of order?.discounts | keyvalue">
        <div class="detail-promo"></div>
        <div class="detail-amount promo-amount">
          {{order?.totals.total  + discount.value.amount | currency: 'USD':'symbol':'1.2-2'}}
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-total">
          {{'REQUEST.PAYMENT.TOTAL' | translate}}
        </div>
        <div class="detail-amount">
          {{order?.totals.total | currency}}
        </div>
      </div>
      <div class="detail-row promo-text" *ngIf="order?.discounts">
        {{'REQUEST.PAYMENT.PROMOTEXT' | translate}} {{totalDiscount | currency: 'USD': 'symbol': '1.2-2'}}
      </div>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
